import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=6383a5ea&"
import script from "./NumberInput.vue?vue&type=script&lang=js&"
export * from "./NumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/irvan/ECLIPSE/br-monorepo/js/solvent_js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6383a5ea')) {
      api.createRecord('6383a5ea', component.options)
    } else {
      api.reload('6383a5ea', component.options)
    }
    module.hot.accept("./NumberInput.vue?vue&type=template&id=6383a5ea&", function () {
      api.rerender('6383a5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/solvent/NumberInput.vue"
export default component.exports